(function () {
  const el = document.querySelector("[data-countdown]");
  if (!el) return;

  const target = new Date(el.getAttribute("data-countdown")).getTime();
  if (isNaN(target)) return;

  const parts = {
    days: el.querySelector("[data-cd-days]"),
    hours: el.querySelector("[data-cd-hours]"),
    mins: el.querySelector("[data-cd-mins]"),
    secs: el.querySelector("[data-cd-secs]"),
  };

  const pad = (n) => String(n).padStart(2, "0");

  function tick() {
    const now = Date.now();
    let diff = Math.max(0, target - now);

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    if (parts.days) parts.days.textContent = d;
    if (parts.hours) parts.hours.textContent = pad(h);
    if (parts.mins) parts.mins.textContent = pad(m);
    if (parts.secs) parts.secs.textContent = pad(s);
  }

  tick();
  setInterval(tick, 1000);
})();